exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hide-placeholder input::placeholder {\n  color: transparent !important;\n}\n\n.tag-select md-select-menu {\n  margin-left: 200px;\n}\n\n.create-company-fieldset {\n  margin-top: 8px;\n  width: 656px;\n}\n", ""]);

// exports
